module.exports = __webpack_public_path__ + "img/removeskill.aa863915.svg";